<template>
  <div class="flex flex-col gap-6">
    <WarningDisable permission="bruteforce" />
    <div class="grow">
      <div class="mb-2 flex items-baseline justify-between">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử dò mật khẩu
        </div>
        <button class="btn btn-primary" @click="showScanModal = true">
          <i class="fa-solid fa-search mr-2"></i>
          Quét
        </button>
      </div>
      <Loading v-if="action_store.loading.get_action_history" />
      <template v-else-if="action_store.total_filter > 0">
        <div class="bg-base-100 mb-4 overflow-x-auto">
          <table class="table-pin-rows table-md table">
            <thead>
              <tr>
                <th></th>
                <th>IP Mục tiêu</th>
                <th>Người dùng</th>
                <th>Tùy chọn</th>
                <th>Trạng thái</th>
                <th>Thời gian tạo</th>
              </tr>
            </thead>
            <tbody class="bg-base-200">
              <tr
                v-for="(action, idx) in action_store.actions"
                :key="action.id"
                class="hover:bg-base-300 cursor-pointer transition-colors"
                @click="
                  $router.push({
                    name: 'ClientBruteForceScanDetail',
                    params: {
                      action_id: action.id,
                    },
                  })
                "
              >
                <th>
                  {{
                    idx +
                    1 +
                    (number_from_query("page", 1) - 1) *
                      number_from_query("size", 24)
                  }}
                </th>
                <td>
                  {{ action.ip || "N/A" }}
                </td>
                <td>
                  <div
                    v-if="action.us && isFilePath(action.us)"
                    class="flex items-center gap-2"
                  >
                    <span
                      class="text-xs italic opacity-75"
                      :title="action.us"
                      >{{
                        action.upload_filename || getFileName(action.us)
                      }}</span
                    >
                    <button
                      v-if="action.id"
                      class="btn btn-xs btn-outline"
                      @click.stop="
                        downloadUsernameFile(
                          action.id as string,
                          action.us as string,
                        )
                      "
                      title="Tải xuống"
                    >
                      <i class="fa-solid fa-download"></i>
                    </button>
                  </div>
                  <div
                    v-else
                    class="max-w-37.5 truncate"
                    :title="action.us || 'N/A'"
                  >
                    {{ action.us || "N/A" }}
                  </div>
                </td>
                <td>
                  <span class="badge badge-ghost badge-sm">
                    {{
                      action.option === "ip"
                        ? "1 IP"
                        : action.option === "range"
                          ? "Dải IP"
                          : action.option === "auto"
                            ? "Tự động"
                            : action.option || "N/A"
                    }}
                  </span>
                </td>
                <td>
                  <ActionStatusBadge :status="action.status" />
                </td>
                <td class="whitespace-nowrap">
                  {{ dayjs(action.created).fromNow() }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :total_pages="action_store.total_pages" />
      </template>
      <NotFound v-else />
    </div>

    <!-- Scan Modal -->
    <BruteForceScanModal
      v-model:open="showScanModal"
      @scanned="handleScanned"
    />
  </div>
</template>

<script setup lang="ts">
import { number_from_query } from "@/api";
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { downloadFileFromUrl } from "@/composables/useDownload";
import dayjs from "dayjs";
import { onMounted, ref } from "vue";
import { use_action } from "../ExplorerV2/useAction";
import WarningDisable from "../WarningDisable.vue";
import BruteForceScanModal from "./BruteForceScanModal.vue";

const action_store = use_action();
const showScanModal = ref(false);

const isFilePath = (text: string) => {
  return (
    text &&
    (text.startsWith("./tmp/") ||
      text.startsWith("http://") ||
      text.startsWith("https://"))
  );
};

const getFileName = (path: string) => {
  return path.split("/").pop() || path;
};

const downloadUsernameFile = (id: string, user: string) => {
  const url = user.startsWith("http")
    ? user
    : `/api/v1/view/password-detection/user/${id}`;
  const filename = getFileName(user);
  downloadFileFromUrl(url, filename);
};

onMounted(() => {
  loadData();
});

const loadData = () => {
  action_store.get_action_history({
    type: "password_detection",
    action: "scan",
  });
};

const handleScanned = () => {
  setTimeout(() => {
    loadData(); // Reload list to show new scan
  }, 1000);
};
</script>
